import styled from '@emotion/styled';
import {colors, sizes} from 'patient-ping-remedy/packages/theme';

export const WidgetWrapper = styled.div`
  width: 58rem;
  padding: ${sizes.medium} ${sizes.small};
`;

export const WidgetPageLink = styled.button`
  padding: 0.5rem;
  background: none;
  border: none;
  cursor: pointer;

  svg {
    font-size: ${sizes.small};
    color: ${colors.charcoal};
  }
`;
